import { Observer, Subject, Subscription, SubscriptionLike } from "rxjs";
import {isEqualJSON} from '../util/util'


export interface TLMDControl<T>  extends SubscriptionLike {
	/**
	call this method to 'manually' set the value of this control. This call will not result in an invocation of the ValueChange Observers
	The given value will be kept as the value where to reset to when the value has been changed by the user 
	@param value the value to set
	@return the control therby allowing chaining 
	@method 
	 */
	setValue(value: T): TLMDControl<T>;
	/**
	returns the current value
	 */
	getValue(): T;
	/**
	Resets the current value to the value supplied in the call to 'setValue'
	@return the value after the reset
 */
	resetValue(): T;
}

export abstract class Control<T> extends Subject<T> implements TLMDControl<T> {

	private value: T;
	private startValue: T;

	public constructor() {
		super();
	}

	public setValue(value: T): TLMDControl<T> {
		const changed = !isEqualJSON(this.value, value);
		this.startValue = value;
		this.value = value;
		if(changed) {
			//broadcast new value
			this.next(this.value);
		}
		return this;
	}
	
	public getValue(): T {
		return this.value;
	};

	public resetValue(): T {
		this.setValue(this.startValue);
		return this.value;
	};
	
}

/**
@property parent optional element where to call querySelector on with the given selector property. When not given, the document body will be used  
@property selector the query selector to use on the parent property in order to arrive at this  control's container
 */
export interface ControlOptions {
	selector: string,
	parent?: HTMLElement
}

export abstract class UIControl<T> extends Control<T>  {
	private container: HTMLElement;
	private subscriptions: Subscription[] = [];
	
	public constructor(private options: ControlOptions) {
		super();
		if (this.options.parent === undefined) this.options.parent = document.body;
		this.container = this.getParent().querySelector(this.getContainerSelector());
		window.requestAnimationFrame((_timestep: number) => this.build());
	}
		protected abstract build(): void;

	public getOptions(): ControlOptions {
		return this.options;
	}
	public getParent(): HTMLElement {
		return this.options.parent;
	}
	public getContainerSelector(): string {
		return this.options.selector;
	}
	public getContainer(): HTMLElement {
		return this.container;
	}
	/**
	 * Call this method to add subscriptions to content dom elements.
	 * These elements get removed upon each call to Open) -> buildContainer()
	 * so by registering the subscriptions, they get properly unsubscribed.
	 */
	protected addSubscription(subscription: Subscription): TLMDControl<T> {
		this.subscriptions.push(subscription);
		return this;
	}


	public release(): TLMDControl<T> {
		if (this.subscriptions && this.subscriptions.length > 0) {
			this.subscriptions.forEach(subscription => subscription.unsubscribe());
			this.subscriptions.length = 0;
		}
		return this;
	}

}



